export default __webpack_public_path__ + "static/char-s-21-ko-ab1c863188c98e61b7ca4e486088e89e.webp";